import { Component, OnInit, Input } from '@angular/core';
import { VideoService } from '../../services/video.service';
import { MatDialog } from '@angular/material';
import { QuizComponent } from './quiz/quiz.component';

@Component({
  selector: 'app-video-cme',
  templateUrl: './video-cme.component.html',
  styleUrls: ['./video-cme.component.scss']
})
export class VideoCmeComponent implements OnInit {


  @Input()  videoItem: any;
  
  isCmeAvaiable : boolean = false;

  cmeQuizItem : any;

  constructor(public dialog: MatDialog,private videoService : VideoService) { }

  ngOnInit() {
    //getInstructorDetails
    //getVideoInstructor
  }

  openDialog() {
    const dialogRef = this.dialog.open(QuizComponent,{
      data: { cmeQuizItem: this.cmeQuizItem },
      height: '98%',
      width: '100vw',
      panelClass: 'full-screen-modal'
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }

  ngOnChanges(){
    console.log("instructors"+JSON.stringify(this.videoItem));
    this.getCMEDetailsFromServer();
  }

  getCMEDetailsFromServer(){
    var body = {"media_id":""+this.videoItem._id.$oid};
    //var body = {"media_id":"58f139a090762600046ca3d1"};
    console.log("id"+JSON.stringify(body));
    
    this.videoService.getVideoCME(body).subscribe((resp : any) => {
      this.onVideoDetailsSuccess(resp);
      }, (err) => {
    // Unable to log in
          this.onVideoDetailsFetchError(err);    
    });

  }


  onVideoDetailsSuccess(resp){
      console.log("On Instructor : "+JSON.stringify(resp));
      if(resp.$undefined == true){
        this.isCmeAvaiable = false;
      }else{
        this.isCmeAvaiable = true;
        this.cmeQuizItem = resp;
      }
  }

  onVideoDetailsFetchError(err){

  }


  openQuiz(){

  }


}
